export default __webpack_public_path__ + "2e31b03acf839ea40bbaceb20fa52927.png";